export const GLOBAL_SEARCH_PARAMETERS_OPTIONS_WITH_ICON = [
  {
    label: 'Project#',
    value: 'project_number',
    icon: 'pi pi-file',
    className: 'text-yellow-600',
  },
  {
    label: 'PO#',
    value: 'po_number',
    icon: 'pi pi-shopping-cart',
    className: 'text-green-600',
  },
  {
    label: 'Client',
    value: 'client',
    icon: 'pi pi-user ',
    className: 'text-pink-600',
  },
  {
    label: 'Phone',
    value: 'phone',
    icon: 'pi pi-phone',
    className: 'text-indigo-600',
  },
  {
    label: 'Address',
    value: 'address',
    icon: 'pi pi-map-marker',
    className: 'text-teal-600',
  },
];
